import React, { Fragment, useState } from 'react'
import cx from 'classnames'

import styles from './EditGuide.module.css'
import AddIcon from 'Icons/add.svg'

import Button from 'Design/components/Button'
import Step from './Step'

const GuideSteps = (props) => {
  const { guide } = props
  const { guide_steps: steps = [] } = guide

  const [currentStepId, setCurrentStepId] = useState(null)
  const [newStep, setNewStep] = useState(false)

  const handleAddGuideClick = () => {
    setCurrentStepId(null)
    setNewStep(true)
  }

  const handleSetCurrentStepId = (id) => {
    setNewStep(false)
    setCurrentStepId(id)
  }

  const handleCancelClick = () => {
    setCurrentStepId(null)
    setNewStep(false)
  }

  const showAddGuideButton = currentStepId || newStep

  return (
    <Fragment>
      <div>
        {steps.map((step, index) => {
          return (
            <div
              className={cx(styles.Step, { [styles.StepActive]: currentStepId === step.id })}
              key={'Guide_step__' + step.id}
            >
              <div className={styles.TimelineBadge}>{index + 1}</div>
              <Step
                guide={guide}
                step={step}
                currentStepId={currentStepId}
                setCurrentStepId={handleSetCurrentStepId}
                onCancelClick={handleCancelClick}
                canDeleteStep={steps.length > 1}
              />
            </div>
          )
        })}

        {newStep && (
          <div className={cx(styles.Step, styles.StepActive)}>
            <div className={styles.TimelineBadge}>{steps.length + 1}</div>
            <Step guide={guide} onCancelClick={handleCancelClick} mode='create' />
          </div>
        )}
      </div>

      {!showAddGuideButton && (
        <Button variant='secondary' type='submit' onClick={handleAddGuideClick} className={styles.AddGuideButton}>
          Add New Guide Step
          <span className={styles.AddIcon}>
            <AddIcon />
          </span>
        </Button>
      )}
    </Fragment>
  )
}

export default GuideSteps
